module.exports = __webpack_public_path__ + "static/media/our-proejcts-img5.971731e8.png";